import { z } from 'zod';

/** Durable execution state of a piece, kept on `case_documents` beside short-lived Redis progress. */
export const SynthesisTechnicalStatusSchema = z.enum([
  'queued',
  'processing',
  'completed',
  'failed',
]);
export type SynthesisTechnicalStatus = z.infer<typeof SynthesisTechnicalStatusSchema>;

export const SynthesisRecoveryKindSchema = z.enum([
  'alternate_ocr',
  'native_pdf',
  'vision',
  'alternate_llm',
]);
export type SynthesisRecoveryKind = z.infer<typeof SynthesisRecoveryKindSchema>;

/**
 * Browser-safe projection returned by `POST /documents/batch-synthesis-status`.
 * It carries no provider name, model, error code or raw error: only a stage
 * name, a bounded recovery kind and a sanitized French message.
 */
export const SynthesisProcessingStatusSchema = z.object({
  technicalStatus: SynthesisTechnicalStatusSchema,
  /** Read by the server only, to derive an enrichment-only retry after an LLM-stage failure. */
  lastStage: z.string(),
  /** Null on a completed piece means it succeeded on the primary path. */
  recoveryKind: SynthesisRecoveryKindSchema.nullable(),
  /** Set only on a failed piece. */
  userMessage: z.string().nullable(),
});
export type SynthesisProcessingStatus = z.infer<typeof SynthesisProcessingStatusSchema>;
